import {
  GET_PAGE_DATA,
  GET_PAGE_DATA_SUCCESS,
  GET_PAGE_DATA_ERROR,
  GET_COLLECTION_OPTIONS,
  GET_COLLECTION_OPTIONS_SUCCESS,
  GET_COLLECTION_OPTIONS_ERROR,
} from "../actions";

const INIT_STATE = {
  pageId: null,
  pageData: null,
  allBlocks: null,
  collectionOptionsData: null,
  pageDataRetrieveError: "",
  getCollectionOptionsError: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PAGE_DATA:
      return {
        ...state,
        loading: true,
        pageId: action.payload.pageId,
        pageDataRetrieveError: "",
      };
    case GET_PAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        pageDataRetrieveError: "",
        pageData: action.payload
      };
    case GET_PAGE_DATA_ERROR:
      return { ...state, loading: false, pageDataRetrieveError: action.payload ? action.payload.message : "" };
    case GET_COLLECTION_OPTIONS:
      return {
        ...state,
        loading: true,
        getCollectionOptionsError: "",
      };
    case GET_COLLECTION_OPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        getCollectionOptionsError: "",
        collectionOptionsData: action.payload
      };
    case GET_COLLECTION_OPTIONS_ERROR:
      return { ...state, loading: false, getCollectionOptionsError: action.payload ? action.payload.message : "" };
    default:
      return { ...state };
  }
};
